export class NavItem {
    itemId?: string;
    itemIcon?: string;
    itemName?: string;
    itemState? = true;
    itemGo: string[];
}
